import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { getSearch, RouterRootState } from 'connected-react-router';
import { createSelector } from 'reselect';
import { AggregationEvents } from 'components/pages/PageProductCalendar/AggregationEvents';
import { smartAggregationSelector, eventDateSelector } from 'modules/search/selectors';
import { productTypeCalendarSelector } from 'modules/productTypes/selectors';
import { searchPromotionalBannerProductSelector } from 'modules/search/selectors';
import { changeFilter } from 'modules/search';
import { emptyArray } from 'utils';
import { FilterNames } from 'constants/index';

const mapActionCreators = (dispatch: Dispatch) => ({
  changeFilter(name: string, value: string): void {
    dispatch(
      changeFilter(name, value, {
        replaceValues: name === FilterNames.EVENT_START_DATE || name === FilterNames.EVENT_END_DATE,
      })
    );
  },
});

const mapStateToProps = () => {
  const webcastPassFilterItemSelector = createSelector(
    [smartAggregationSelector],
    (aggs: State.SearchAggs | null): number => aggs?.hasWebcastPass?.['1'] || emptyArray
  );

  const getFilterSelectedItems = (values: string) => (Array.isArray(values) ? values : [values].filter(Boolean));

  return (state: State.Root & RouterRootState) => {
    const search = getSearch(state);
    const parsedQueryParams = parse(search, {
      arrayFormat: 'comma',
      parseNumbers: true,
    });

    const { includedInWebcastPass, eventStartDate, eventEndDate }: any = parsedQueryParams;

    return {
      productType: productTypeCalendarSelector(state),
      webcastPassFilterItems: webcastPassFilterItemSelector(state),
      webcastPassFilterSelectedItems: getFilterSelectedItems(includedInWebcastPass),
      eventDateFilterItems: eventDateSelector(state),
      eventStartDateSelectedItems: getFilterSelectedItems(eventStartDate),
      eventEndDateSelectedItems: getFilterSelectedItems(eventEndDate),
      webcastPass: searchPromotionalBannerProductSelector(state),
    };
  };
};

export const AggregationEventsContainer = connect(mapStateToProps, mapActionCreators)(AggregationEvents);
